import moment from "@/utils/moment";

function buildAddressAttributes(address) {
  return {
    street: address.street,
    street_number: address.street_number,
    complement: address.complement,
    district: address.district,
    city: address.city,
    state: address.state,
    country: address.country,
    zip_code: address.zip_code.toString()
  };
}

function buildPhoneAttributes(phone) {
  return {
    country_code: phone.country_code,
    area_code: phone.area_code,
    number: phone.number
  };
}

function buildPaymentGatewayCustomerAttributes(payload) {
  let fullname =
    payload.type === "legals"
      ? payload.business_name
      : `${payload.account.first_name} ${payload.account.last_name}`;

  return {
    email: payload.account.email,
    document_type: payload.document.document_type,
    document_number: payload.document.document_number,
    fullname,
    birthdate: moment(payload.account.profile.birthdate).format("Y-MM-DD"),
    phone: buildPhoneAttributes(payload.phone),
    address: buildAddressAttributes(payload.address)
  };
}

function buildPaymentGatewayCustomerRelationships(payload) {
  return {
    customer: {
      data: {
        type: payload.type,
        id: payload.id
      }
    }
  };
}

function createPGCRequestBody(payload) {
  return {
    data: {
      type: "payment_gateway_customers",
      attributes: buildPaymentGatewayCustomerAttributes(payload),
      relationships: buildPaymentGatewayCustomerRelationships(payload)
    }
  };
}

export default {
  createPGCRequestBody
};



// WEBPACK FOOTER //
// ./src/API/helpers/paymentGatewayCustomer.js